export const CLASS_NAMES = {
  commentsContainer: 'react-comments-container',
}
